import { IScreen } from '../../shared/services/types/screen';
import { isEqualDateOnly } from '../../shared/utils/date';

export const isScreenAlmostObsolete = ({ campaign, enabled, futureCampaigns }: IScreen) =>
  !!campaign && enabled && isEqualDateOnly(new Date(campaign.endDate)) && futureCampaigns === 0;
